// extracted by mini-css-extract-plugin
export default {"image":"avatar_image__Pj9F4","small":"avatar_small__VL1wq","medium":"avatar_medium__ZqauU","large":"avatar_large__kLYoT"};